import * as React from 'react';
import type { SVGProps } from 'react';

const SvgSkillIconHover = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill="#d04237"
      d="M15.987.313a1.038 1.038 0 0 0-1.486 0L.846 13.977c-.157.156-.261.365-.287.6l-.547 4.25a1.03 1.03 0 0 0 .286.86c.209.209.47.313.73.313h.13l4.274-.574a1 1 0 0 0 .6-.286L19.687 5.476a1.03 1.03 0 0 0 .313-.73.947.947 0 0 0-.313-.73l-3.7-3.703Zm-.73 2.216 2.215 2.217-.182.183-.313-.313-1.902-1.904.182-.183ZM3.4 17.601l-.965-.965.965.965Zm-.13-3.077L13.588 4.198l.365.365L3.634 14.89l-.365-.366Zm2.214 2.217-.365-.365L15.44 6.05l.365.365L5.484 16.74Z"
    />
  </svg>
);
export default SvgSkillIconHover;
